<template>
  <LayoutBaseContent class="max-w-7xl">
    <LayoutPanel>
      <UtilIframe :url="compUrl" class="mt-0 terms-iframe" />
    </LayoutPanel>
  </LayoutBaseContent>
</template>

<script>
import { get } from 'lodash'
import LayoutBaseContent from '@/components/layout/LayoutBaseContent'
import LayoutPanel from '@/components/layout/LayoutPanel'
import UtilIframe from '@/components/utils/UtilIframe'

export default {
  name: 'Terms',
  components: {
    LayoutBaseContent,
    LayoutPanel,
    UtilIframe
  },
  head: {
    title() {
      return {
        inner: 'Terms & Conditions'
      }
    }
  },
  computed: {
    compUrl() {
      const termsType = get(this, '$route.params.type', '')

      switch (termsType) {
        case 'farmpay': {
          return 'https://docs.google.com/document/d/e/2PACX-1vRT21Pf6Ef2I9iy6oHBAOcNN_XSpeQJI9IJK-pZ2_LpL8jSWNp6tqjT4tAkk1OZEy3tYVCxbMCa-S_j/pub?embedded=true'
        }
        case 'cookies': {
          return 'https://docs.google.com/document/d/e/2PACX-1vQj5VWzdfyuzQUwTbEdpt3H0HNjQYLI4xESlNovL_N-s2gsLytgB8QpCZE6ft2kN1cthuR6DC9Pzrar/pub?embedded=true'
        }
        default: {
          return 'https://docs.google.com/document/d/e/2PACX-1vSJpb8fGDgVyH5ByAHOx1I4uSeYBkP5fUdnxJRUMnTF6zdEvFo9FKf57UZOvYQG3U7ZkcwNkjF4IPa2/pub?embedded=true'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.terms-iframe {
  height: 90vh;
}
</style>
